import { useEffect, useState } from "preact/hooks";
import { store } from "./index.ts";
import type { StoreKey } from "./createStore.ts";

/**
 * Reads a store key and re-renders when it changes.
 *
 * The store already had the shape a hook needs — subscribe returns its own unsubscribe, and set
 * compares with === instead of mutating — so this is the whole bridge between it and the components.
 */
export function useStore<V>(key: StoreKey<V>): V {
    const [value, setValue] = useState<V>(() => store.get(key));
    useEffect(() => {
        // Not redundant: a response can land between the render and this effect, and that change
        // would otherwise be missed until the next one.
        setValue(store.get(key));
        return store.subscribe(key, () => setValue(store.get(key)));
    }, [key]);
    return value;
}
